import CanvasEditor from "./components/canvasEditor/CanvasEditor";
import AppLogoBar from "./components/AppLogoBar";
import { useTranslation } from "react-i18next";
import { Container } from "@mui/material";
const AppRoot = () => {
  const { t } = useTranslation();
  return (
    <div className="AppRoot">
      <AppLogoBar />
      <CanvasEditor />
      <Container>
        <div>{t("siteDescription")}</div>
      </Container>
    </div>
  );
};
export default AppRoot;
